module.exports = __webpack_public_path__ + "img/pieceOneImg3.aec77c8.webp";